const GET_PROJECT_REQUEST = "GET_PROJECT_REQUEST";
const GET_PROJECT_SUCCESS = "GET_PROJECT_SUCCESS";
const GET_PROJECT_FAILURE = "GET_PROJECT_FAILURE";

const ADD_PROJECT_REQUEST = "ADD_PROJECT_REQUEST";
const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS";
const ADD_PROJECT_FAILURE = "ADD_PROJECT_FAILURE";


const DELETE_PROJECT_REQUEST = "DELETE_PROJECT_REQUEST";
const DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS";
const DELETE_PROJECT_FAILURE = "DELETE_PROJECT_FAILURE";

const PATCH_PROJECT_REQUEST = "PATCH_PROJECT_REQUEST";
const PATCH_PROJECT_SUCCESS = "PATCH_PROJECT_SUCCESS";
const PATCH_PROJECT_FAILURE = "PATCH_PROJECT_FAILURE";

export { ADD_PROJECT_FAILURE, ADD_PROJECT_REQUEST, ADD_PROJECT_SUCCESS ,GET_PROJECT_FAILURE,GET_PROJECT_REQUEST,GET_PROJECT_SUCCESS,DELETE_PROJECT_FAILURE,DELETE_PROJECT_REQUEST,DELETE_PROJECT_SUCCESS,PATCH_PROJECT_FAILURE,PATCH_PROJECT_REQUEST,PATCH_PROJECT_SUCCESS};
